import React from 'react';
class Spin extends React.Component {
  render() {
    return <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>;
  }
}

export default Spin;